module.exports = __webpack_public_path__ + "static/media/g.10ebf20a.png";